import AsyncStorage from "@react-native-community/async-storage";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dimensions, Text, View } from "react-native";

import { Feature } from "ol";
import { Point } from "ol/geom";
import { fromLonLat, toLonLat } from "ol/proj";
import { getDistance } from "ol/sphere";
import { RFeature, RGeolocation, RLayerVector, RMap, RStyle } from "rlayers";

import FlashMessage from "react-native-flash-message";
import PopUpMapaHistoria from "../PopUps/PopUpMapaHistoria";
import PopUpInicial from "../PopUps/PopUpMapaInicial";

import { useFocusEffect } from "@react-navigation/native";
import * as Location from "expo-location";
import Loading from "../../components/Loading";
import getAngleCompass from "../../Functions/getAngleCompass";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";
import Menu from "../menu";
import PopUpFinal from "../PopUps/PopUpFinal";
import RenderLayout from "./Layouts";
import PoisMapa from "./Pois";

/*
    llibreria de mapa https://mmomtchev.github.io/rlayers/api/
*/

function Mapa(RouterData) {
  const { itinerari, currentItinerari, recursos, idioma, projecte } =
    RouterData.route.params;

  // Get first POI coordinates for initial map center
  const firstPoi =
    currentItinerari?.pois?.find((poi) => poi.isFirst) ||
    currentItinerari?.pois?.[0];
  const firstPoiLocation =
    firstPoi && firstPoi.location
      ? fromLonLat([
          parseFloat(firstPoi.location[0]),
          parseFloat(firstPoi.location[1]),
        ])
      : fromLonLat([2.452541, 42.12033]);

  const [location, setLocation] = useState(firstPoiLocation);
  const [pointLocation, setPointLocation] = useState(firstPoiLocation);
  const [gettingLocation, setGettingLocation] = useState(true);
  const [width, setWidth] = useState(Dimensions.get("window").width);
  const [height, setHeight] = useState(Dimensions.get("window").height * 0.899);
  const [loaded, setLoaded] = useState(false);
  const [ModalIniciVisible, setModalIniciVisible] = useState(true);
  const [ModalHistoria, setModalHistoria] = useState(false);
  const [ModalFinal, setModalFinal] = useState(true);
  const [features, setFeatures] = useState([]);
  const [currentPoi, setCurrentPoi] = useState(null);
  /*Token per el popUpFinal i altres peticions per analitiques */
  const [token, setToken] = useState("");
  const [angle, setAngle] = useState(0);
  const [deviceOrientation, setDeviceOrientation] = useState(null);
  const [geolocationKey, setGeolocationKey] = useState(0);
  const mapRef = useRef(null);
  const olMapRef = useRef(null); // Referencia directa al mapa de OpenLayers
  const watchLocationSubscription = useRef(null);

  const poi = itinerari.pois.find((e) => e.id == currentPoi);

  window.addEventListener("resize", () => {
    setWidth(Dimensions.get("window").width);
    setHeight(Dimensions.get("window").height * 0.899);
  });

  // get devuice absolute orientation
  // window.addEventListener('deviceorientationabsolute', (e) => {
  //     console.log('====================================');
  //     console.log(e.alpha);
  //     console.log('====================================');
  //     setDeviceOrientation(e.alpha);
  // });

  useEffect(() => {
    AsyncStorage.getItem("token").then((token) => {
      if (token) {
        setToken(token);
      }

      if (currentItinerari.comencat) {
        setModalIniciVisible(false);
      }

      // Gyroscope.setUpdateInterval(10000);
      // Gyroscope.addListener(gyroscopeData => {
      //     console.log(gyroscopeData);
      // });
    });
  }, []);

  useFocusEffect(
    useCallback(() => {
      const init = async () => {
        await Location.enableNetworkProviderAsync();

        const { status } = await Location.requestForegroundPermissionsAsync();

        if (status !== "granted") {
          console.log("Permission to access location was denied");

          alert(
            "No has habilitat els permisos per accedir la localització. Torna a intentar-ho"
          );
          setGettingLocation(false);
          return;
        }

        // Forzar geolocalización inmediatamente con alta precisión
        const location2 = await Location.getCurrentPositionAsync({
          accuracy: Location.Accuracy.BestForNavigation,
          maximumAge: 0,
        });
        const newLocation = fromLonLat([
          location2.coords.longitude,
          location2.coords.latitude,
        ]);
        setLocation(newLocation);
        setPointLocation(newLocation);
        setAngle(
          getAngleCompass(
            currentItinerari.pois,
            [location2.coords.longitude, location2.coords.latitude],
            currentItinerari.currentOrder
          )
        );
        setGettingLocation(false);

        // Iniciar seguimiento continuo de la ubicación
        watchLocationSubscription.current = await Location.watchPositionAsync(
          {
            accuracy: Location.Accuracy.BestForNavigation,
            timeInterval: 2000,
            distanceInterval: 5,
          },
          (locationUpdate) => {
            const updatedLocation = fromLonLat([
              locationUpdate.coords.longitude,
              locationUpdate.coords.latitude,
            ]);
            setLocation(updatedLocation);
            setPointLocation(updatedLocation);
            setAngle(
              getAngleCompass(
                currentItinerari.pois,
                [locationUpdate.coords.longitude, locationUpdate.coords.latitude],
                currentItinerari.currentOrder
              )
            );
          }
        );

        // Forzar actualización del componente RGeolocation
        setGeolocationKey((prev) => prev + 1);
      };

      init();

      initMapa();

      return () => {
        setLoaded(false);
        // Detener el seguimiento de ubicación cuando se desmonta
        if (watchLocationSubscription.current) {
          watchLocationSubscription.current.remove();
          watchLocationSubscription.current = null;
        }
      };
    }, [currentItinerari])
  );

  const initMapa = async () => {
    const features = currentItinerari.pois.map((element) => {
      return new Feature({
        geometry: new Point(
          fromLonLat([
            parseFloat(element.location[0]),
            parseFloat(element.location[1]),
          ])
        ),
        uid: element.id,
        name: element.Nom,
        id: element.id,
      });
    });

    setFeatures(features);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 500);
  }, [features]);

  // Forzar geolocalización cuando el mapa está cargado
  useEffect(() => {
    if (loaded) {
      const forceLocationUpdate = async () => {
        try {
          const { status } = await Location.getForegroundPermissionsAsync();
          if (status === "granted") {
            const location2 = await Location.getCurrentPositionAsync({
              accuracy: Location.Accuracy.BestForNavigation,
              maximumAge: 0,
            });
            const newLocation = fromLonLat([
              location2.coords.longitude,
              location2.coords.latitude,
            ]);
            setLocation(newLocation);
            setPointLocation(newLocation);
            setAngle(
              getAngleCompass(
                currentItinerari.pois,
                [location2.coords.longitude, location2.coords.latitude],
                currentItinerari.currentOrder
              )
            );
            setGettingLocation(false);
          }
        } catch (error) {
          console.log("Error al forzar geolocalización:", error);
        }
      };

      // Forzar inmediatamente y después de un pequeño delay para asegurar
      forceLocationUpdate();
      const timeoutId = setTimeout(forceLocationUpdate, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [loaded, currentItinerari]);

  // Callback para capturar la instancia del mapa de OpenLayers cuando esté disponible
  const mapRefCallback = useCallback((node) => {
    if (node) {
      mapRef.current = node;
      // Intentar obtener el mapa de OpenLayers de diferentes maneras
      const tryGetMap = () => {
        if (!node) return null;
        
        if (node.ol) return node.ol;
        if (node.getMap && typeof node.getMap === 'function') return node.getMap();
        if (node.context && node.context.map) return node.context.map;
        if (node.getView && typeof node.getView === 'function') return node;
        if (node._ol) return node._ol;
        
        // Si es un componente React, intentar acceder al estado interno
        if (node._reactInternalFiber || node._reactInternalInstance) {
          const fiber = node._reactInternalFiber || node._reactInternalInstance;
          if (fiber && fiber.memoizedState) {
            const state = fiber.memoizedState;
            if (state.memoizedState && state.memoizedState.ol) {
              return state.memoizedState.ol;
            }
          }
        }
        
        return null;
      };
      
      // Intentar obtener el mapa inmediatamente y después de un delay
      const map = tryGetMap();
      if (map) {
        olMapRef.current = map;
      } else {
        // Si no está disponible inmediatamente, intentar después de un delay
        setTimeout(() => {
          const delayedMap = tryGetMap();
          if (delayedMap) {
            olMapRef.current = delayedMap;
          }
        }, 500);
      }
    } else {
      mapRef.current = null;
      olMapRef.current = null;
    }
  }, []);

  // Centrar el mapa y seguir al usuario cuando cambia la ubicación
  useEffect(() => {
    if (loaded && pointLocation) {
      const timeoutId = setTimeout(() => {
        try {
          let map = olMapRef.current;
          
          // Si no tenemos la referencia directa, intentar obtenerla del mapRef
          if (!map && mapRef.current) {
            if (mapRef.current.ol) {
              map = mapRef.current.ol;
              olMapRef.current = map;
            } else if (mapRef.current.getMap && typeof mapRef.current.getMap === 'function') {
              map = mapRef.current.getMap();
              olMapRef.current = map;
            } else if (mapRef.current.getView && typeof mapRef.current.getView === 'function') {
              map = mapRef.current;
              olMapRef.current = map;
            }
          }
          
          if (map && typeof map.getView === 'function') {
            const view = map.getView();
            if (view && typeof view.setCenter === 'function') {
              view.setCenter(pointLocation);
              // Forzar actualización de la vista
              if (typeof view.changed === 'function') {
                view.changed();
              }
            }
          }
        } catch (error) {
          console.log("Error al centrar el mapa:", error);
        }
      }, 300);
      
      return () => clearTimeout(timeoutId);
    }
  }, [pointLocation, loaded]);

  const activarPoi = (poi) => {
    setCurrentPoi(poi.id);

    setModalHistoria(true);

    poi.popUpLoaded = true;
  };

  // Efecto para comprobar si el usuario está cerca de un POI
  useEffect(() => {
    if (!loaded || ModalHistoria || ModalIniciVisible) {
      return; // No comprobar si no está cargado o hay un modal abierto
    }

    currentItinerari.pois.forEach((poi) => {
      if (poi.done || poi.popUpLoaded) {
        return;
      }

      if (poi.order == currentItinerari.currentOrder) {
        // Convertir pointLocation de EPSG:3857 a lon/lat para getDistance
        const [userLon, userLat] = toLonLat(pointLocation);
        const distance = getDistance(
          [parseFloat(poi.location[0]), parseFloat(poi.location[1])],
          [userLon, userLat]
        );
        const distanciaActivacio =
          itinerari.pois.find((e) => e.id == poi.id)?.metresActivacio || 20;

        if (distance <= distanciaActivacio) {
          activarPoi(poi);
        }
      }
    });
  }, [pointLocation, loaded, ModalHistoria, ModalIniciVisible, currentItinerari]);

  const _renderTrackPosition = () => {
    return (
      <RGeolocation //=> d'aquesta manera s'evita el hack de pokemon go (flaying)
        key={geolocationKey}
        tracking={true}
        trackingOptions={{
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: 10000,
        }}
        onChange={(e) => {
          if (e.target.position_) {
            const newPointLocation = fromLonLat([e.target.position_[0], e.target.position_[1]]);
            setPointLocation(newPointLocation); // per posicionar el punt
            setLocation(newPointLocation); // per posicionar el mapa (usar las mismas coordenadas transformadas)
          }
        }}
      />
    );
  };

  const renderPopUpInicial = () => {
    return !currentItinerari.comencat
      ? PopUpInicial(RouterData, ModalIniciVisible, setModalIniciVisible)
      : null;
  };

  const renderPopUpHistoria = () => {
    if (ModalHistoria && !ModalIniciVisible) {
      if (poi.teHistoria) {
        return PopUpMapaHistoria(
          RouterData,
          poi,
          ModalHistoria,
          setModalHistoria
        );
      }
      return null; // PopUpMapa(RouterData, poi, ModalHistoria, setModalHistoria);
    }
    return null;
  };

  const renderPopUpFinal = () => {
    return currentItinerari.finalitzat
      ? PopUpFinal(RouterData, ModalFinal, setModalFinal, token)
      : null;
  };

  if (!loaded) {
    return <Loading />;
  }

  return (
    <View style={{ flex: 1, backgroundColor: projecte.colorPrincipal2 }}>
      {renderPopUpInicial()}
      {renderPopUpHistoria()}
      {renderPopUpFinal()}

      {gettingLocation && (
        <View
          style={{
            position: "absolute",
            top: 50,
            left: 0,
            right: 0,
            zIndex: 1000,
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            padding: 15,
            marginHorizontal: 20,
            borderRadius: 10,
          }}
        >
          <Text style={{ color: "white", fontSize: 16, fontWeight: "bold" }}>
            {getRecursText(recursos, "getting_location", idioma)}
          </Text>
        </View>
      )}

      <View style={{ opacity: gettingLocation ? 0.3 : 1 }}>
        {pointLocation && (() => {
          // Calcular distancia al POI actual
          const currentPoi = currentItinerari.pois.find(
            (poi) => poi.order === currentItinerari.currentOrder && !poi.done
          );
          let distance = null;
          if (currentPoi && currentPoi.location) {
            const [lon, lat] = toLonLat(pointLocation);
            distance = getDistance(
              [parseFloat(currentPoi.location[0]), parseFloat(currentPoi.location[1])],
              [lon, lat]
            );
          }

          return (
            <View
              style={{
                position: "absolute",
                top: 10,
                left: 10,
                zIndex: 1000,
                flexDirection: "row",
              }}
            >
              <View
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                  padding: 6,
                  borderRadius: 6,
                  minWidth: 120,
                }}
              >
                <Text
                  style={{
                    color: "white",
                    fontSize: 10,
                    fontFamily: "monospace",
                  }}
                >
                  {(() => {
                    const [lon, lat] = toLonLat(pointLocation);
                    return `${lat.toFixed(6)}, ${lon.toFixed(6)}`;
                  })()}
                </Text>
              </View>
              {distance !== null && (
                <View
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    padding: 6,
                    borderRadius: 6,
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 8,
                  }}
                >
                  <Text style={{ fontSize: 12, marginRight: 4 }}>🚩</Text>
                  <Text
                    style={{
                      color: "white",
                      fontSize: 10,
                      fontFamily: "monospace",
                    }}
                  >
                    {Math.round(distance)}m
                  </Text>
                </View>
              )}
            </View>
          );
        })()}
        <RMap
          ref={mapRefCallback}
          width={width}
          height={height}
          initial={{ center: location, zoom: 15 }}
          maxZoom={20}
          noDefaultControls={true}
        >
          {RenderLayout(RouterData)}

          <RLayerVector zindex={10}>
            <RStyle.RStyle>
              <RStyle.RIcon
                src={getRecursURL(recursos, "geolocalitzacio", idioma)}
                scale={0.08}
              />
            </RStyle.RStyle>
            <RFeature geometry={new Point(pointLocation)} />
          </RLayerVector>

          {_renderTrackPosition()}

          {PoisMapa(RouterData, features, location, activarPoi)}
        </RMap>
        <FlashMessage position="top" />
      </View>
      <View style={{ flex: 10 }}>
        <Menu projecte={RouterData.route.params}></Menu>
      </View>
    </View>
  );
}

export default Mapa;

// {PopUpInicial(RouterData)}
// {PopUpMapa(RouterData,itinerari.pois[0])}
// {PopUpMapaHistoria(RouterData,itinerari.pois[0])}
// {PopUpFinal(RouterData)}
